export function isStandalonePWA(): boolean {
  if (typeof window === 'undefined') return false;

  return (
    // iOS
    (window.navigator as any).standalone === true ||
    // Android and others
    window.matchMedia('(display-mode: standalone)').matches
  );
}
export default function isLikelyInAppBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;

  // Never treat installed PWAs as in app browsers
  if (isStandalonePWA()) return false;

  const ua = navigator.userAgent || '';
  const uaLower = ua.toLowerCase();

  // Known in-app browser identifiers
  const inAppIndicators = [
    // Meta
    'fban',
    'fbav',
    'fbios',
    'fb_iab',
    'instagram',

    // TikTok
    'tiktok',

    // Social / messaging
    'twitter',
    'snapchat',
    'line',
    'wechat',
    'micromessenger',
    'whatsapp',
    'discord',
    'slack',

    // Other apps
    'linkedin',
    'pinterest',
    'reddit',

    // Android WebView
    'wv',
  ];

  const isInAppUA = inAppIndicators.some((indicator) =>
    uaLower.includes(indicator)
  );

  // iOS WebView heuristic
  const isIOSWebView =
    /iphone|ipad|ipod/.test(uaLower) && !uaLower.includes('safari');

  return isInAppUA || isIOSWebView;
}
